import styled from "styled-components";
import DiagonalArrow from "../../../assets/icons/diagonal-arrow-right-up.svg";

export const ExternalArrowGlyph = styled.span`
  display: inline-block;
  width: 0.9em;
  height: 0.9em;
  flex: none;
  background-color: currentColor;
  vertical-align: -0.08em;
  mask: url(${DiagonalArrow}) center / contain no-repeat;
  -webkit-mask: url(${DiagonalArrow}) center / contain no-repeat;
`;
